import React from 'react';
import {
    TextInput,
    SelectInput,
    Create,
    FormTab,
    required,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    BooleanInput,
    TabbedForm,
    ArrayInput,
    SimpleFormIterator
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import TitleCheckCom from '../controls/TitleCheckCom';
import UserCheckCom from '../controls/UserCheckCom'
import {RichTextInput} from 'ra-input-rich-text';


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const editStyles = {
    root: { alignItems: "flex-start" },

    inlineBlock: {
      display: "inline-flex",
      marginRight: "8px",
    },

    continer : {
        width: "98%"
    },
    item : {
        marginRight: "10px"
    }
};

const TrainingActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} label='Training List'/>
    </CardActions>
);


const frequent = [
    {
        id : '1',
        name : 'Once'
    },
    {
        id : 'd',
        name : 'Daily'
    },
    {
        id : 'w',
        name : 'Weekly'
    },
    {
        id : 'bw',
        name : 'Bi-Weekly'
    },
    {
        id : 'm',
        name : 'Monthly'
    },
    {
        id : 'q',
        name : 'Quarterly'
    },
    {
        id : 'ba',
        name : 'Bi-Annually'
    },
    {
        id: 'a',
        name: 'Annually'
    },
    {
        id: 'o',
        name: 'Other'
    }
]

const TrainingToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);

const SetrainingCreate =({ classes, ...props }) => (

<Create
    title='New Employee Training'
    {...props}
    actions={<TrainingActions props={props} />}
    >

        <TabbedForm  toolbar={<TrainingToolbar />}>
            <FormTab label="Training" >
                <TextInput source='training_name' label = 'Training Name' validate={required()}/>
                <TextInput source='code' label = 'Training Code'  />
                <SelectInput source="frequency" label='Traning Frequency' choices={frequent}  validate={required()}   formClassName={classes.inlineBlock}/>
                <BooleanInput source="isactive" label='Is an Active Training?' formClassName={classes.inlineBlock} />
                <TextInput source='description' label = 'Description'  rowsMax={2} multiline fullWidth  />
            </FormTab>
            <FormTab label="Exam">
            <ArrayInput source="question" label="Question(s)">
                <SimpleFormIterator>
                <RichTextInput
                    source='passage'
                    label="Passage"
                />
                <TextInput
                    source="quest"
                    label="Question"
                    formClassName={classes.inlineBlock}
                    fullWidth
                    validate={required()}
                />
                <ArrayInput source="Choices" label="Choice(s)">
                    <SimpleFormIterator>
                    <TextInput
                        source="answer"
                        label=""
                        fullWidth
                        formClassName={classes.inlineBlock}
                    />
                    <BooleanInput
                        source="isAnswere"
                        label="Is this an answer?"
                        formClassName={classes.inlineBlock}
                    />
                    </SimpleFormIterator>
                </ArrayInput>
                </SimpleFormIterator>
            </ArrayInput>

            <TextInput
                type="number"
                source="passing_percentage"
                label="Passing Percentage"
                validate={required()}
            />
            <TextInput source="comments" label="Comments" />

            </FormTab>
            <FormTab label="Roles" >
                <TitleCheckCom props={props}  source="roles" />
                <UserCheckCom props={props}  source="users" />
            </FormTab>
        </TabbedForm>
    </Create>
);

export default withStyles(editStyles)(SetrainingCreate);